<template>
  <VContainer>
    <AppPreloader v-if="company.isFetching || !fetched" />
    <VAlert v-else-if="company.fetchError" type="error">
      {{ company.fetchError }}
    </VAlert>
    <div v-else-if="company.isFetched">
      <VRow justify="center">
        <VCol cols="12" md="3" lg="3" xl="2">
          <CompanySmallCard :company="company.data" :show-tabs="true" />
        </VCol>
        <VCol cols="12" md="8">
          <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
            <h3
              :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'title'"
            >
              {{ $t('vacancies') }} {{ company.data.name }}
            </h3>
            <VDivider class="mt-3" />
            <CompanyVacanciesContainer :company-id="id" />
          </VCard>
        </VCol>
      </VRow>
    </div>
    <div v-else />
  </VContainer>
</template>

<script>
import { mdiChevronRight } from '@mdi/js';
import { mapState } from 'vuex';
import AppPreloader from '../components/AppPreloader.vue';
import CompanySmallCard from '../components/Company/CompanySmallCard.vue';
import { safeGet } from '../functions';
import CompanyVacanciesContainer from '../components/Company/CompanyVacanciesContainer.vue';

export default {
  name: 'Vavancies',
  components: {
    CompanyVacanciesContainer,
    CompanySmallCard,
    AppPreloader,
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      chevron: mdiChevronRight,
      fetched: false,
    };
  },
  computed: {
    pageTitle() {
      const companyName = safeGet(this.company, ['data', 'name']);
      if (!companyName) {
        return null;
      }
      return `${this.$t('vacancies')} ${companyName}`;
    },
    ...mapState('company', ['company', 'vacancies']),
  },
  async serverPrefetch() {
    await this.fetch();

    if (this.company.fetchError) {
      this.fetched = true;
      throw new Error(String(this.company.fetchCode));
    }
  },
  async created() {
    await this.$store.dispatch('company/fetchVacancies', this.$route.params.companyId);
  },
  async mounted() {
    await this.$store.dispatch('company/fetchCompany', this.$route.params.companyId);

    if (this?.company?.data?.companyTemplateSettings && this.$route?.query?.preview !== 'true') {
      window.location.href = `${process.env.VUE_APP_CAREER_PORTAL_URL}/${this.id}/vacancies`;
    } else {
      this.fetched = true;
    }
  },
};
</script>

<i18n locale="en" lang="yaml">
  vacancies: Jobs
</i18n>

<i18n locale="ru" lang="yaml">
  vacancies: Вакансии
</i18n>
